import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { StyledGridItemWrapper } from '~/src/root/components/StyledGridItemWrapper/StyledGridItemWrapper';

export const StyledGridItem = styled(StyledGridItemWrapper)`
  margin-left: ${(props) => props.theme.spacing.sm};
`;
